import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ControlProperty } from '../../../../../../common/models';
import { LocalDateRangeModel } from '../../../../../models';
import { AllocationViewActionRequestUliModel } from '../allocation-view-action-request.model';
import { CarrierModel } from '../../../../../../common/models/carrier.model';
import { AllocationViewActionAttachmentsForm } from '../allocation-attachments.model';
import { AllocationViewSecurityModel } from '../allocation-security';
import {
  AllocationViewActionQuestionForm,
  AllocationViewActionQuestionModel,
} from '../allocation-view-action-question.model';
import { TruckModel } from '../TruckModel';

export class AllocationViewDepartureDockModel extends AllocationViewSecurityModel {
  customGoods: boolean;
  dangerousGoods: boolean;
  dockSecurityQuestions: AllocationViewDepartureDockSecurityQuestions;
  dockVerified: boolean;
  freeTextCarrierName: string;
  truckVerified: boolean;
  swapBody: boolean;
  driverSignature: string;
  workerSignature: string;
  driverSignatureSkipped: boolean;
  needSealing: boolean;
  truck: TruckModel;
}

export class AllocationViewDepartureDockSecurityQuestions {
  [key: string]: AllocationViewActionQuestionModel[];
}

export class AllocationViewDepartureDockForm {
  constructor(
    model: AllocationViewDepartureDockModel,
    fb: UntypedFormBuilder,
    public generalInformation: UntypedFormGroup = fb.group(
      new AllocationViewDepartureDockGeneralInformationForm(model),
    ),
    public dockSecurityQuestions: UntypedFormGroup = fb.group(
      new AllocationViewDepartureDockSecurityQuestionsForm(model, fb),
    ),
    public attachments: UntypedFormGroup = fb.group(new AllocationViewDepartureDockAttachmentsForm(model, fb)),
    public signatures: UntypedFormGroup = fb.group(new AllocationViewDepartureDockSignaturesForm(model)),
  ) {}
}

export class AllocationViewDepartureDockGeneralInformationForm {
  constructor(
    model: AllocationViewDepartureDockModel,
    public carrier: ControlProperty<CarrierModel> = [model.carrier, []],
    public freeTextCarrierName: ControlProperty<string> = [model.freeTextCarrierName, []],
    public serviceTime: ControlProperty<LocalDateRangeModel> = [model.serviceTime, []],
    public firstName: ControlProperty<string> = [model.firstName, []],
    public lastName: ControlProperty<string> = [model.lastName, []],
    public customGoods: ControlProperty<boolean> = [model.customGoods, []],
    public propertyOfAnother: ControlProperty<boolean> = [model.propertyOfAnother, []],
    public dangerousGoods: ControlProperty<boolean> = [model.dangerousGoods, []],
    public remainingDrivingTime: ControlProperty<number> = [model.remainingDrivingTime, []],
    public hubId: ControlProperty<number> = [model.hubId, []],
    public truckId: ControlProperty<number> = [model.truckId, []],
    public ulis: ControlProperty<AllocationViewActionRequestUliModel[]> = [model.ulis, []],
    public swapBody: ControlProperty<boolean> = [model.swapBody, []],
  ) {}
}

export class AllocationViewDepartureDockSecurityQuestionsForm {
  constructor(model: AllocationViewDepartureDockModel, fb: UntypedFormBuilder) {
    const keys = Object.keys(model.dockSecurityQuestions).sort();

    keys.forEach((key: string, index: number) => {
      const isLast = keys.length - 1 === index;

      this[key] = fb.group(new AllocationViewDepartureDockSecurityQuestionForm(model, fb, key, isLast));
    });
  }
}

export class AllocationViewDepartureDockSecurityQuestionForm {
  public securityCheckPassed?: UntypedFormControl;

  constructor(
    model: AllocationViewDepartureDockModel,
    fb: UntypedFormBuilder,
    key: string,
    isLast: boolean,
    public questions: UntypedFormArray = fb.array([]),
  ) {
    model.dockSecurityQuestions[key].forEach((question: AllocationViewActionQuestionModel) => {
      questions.push(fb.group(new AllocationViewActionQuestionForm(question)));
    });

    if (isLast) {
      this.securityCheckPassed = fb.control(null, [Validators.required]);
    }
  }
}

export class AllocationViewDepartureDockAttachmentsForm {
  constructor(
    model: AllocationViewDepartureDockModel,
    fb: UntypedFormBuilder,
    public comments: UntypedFormGroup = fb.group(new AllocationViewActionAttachmentsForm(model.comments, fb)),
    public needSealing: ControlProperty<boolean> = [model.needSealing, []],
  ) {}
}

export class AllocationViewDepartureDockSignaturesForm {
  constructor(
    model: AllocationViewDepartureDockModel,
    public driverSignature: ControlProperty<string> = [model.driverSignature, [Validators.required]],
    public driverSignatureSkipped: boolean = model.driverSignatureSkipped,
    public workerSignature: ControlProperty<string> = [model.workerSignature, [Validators.required]],
  ) {}
}
